export const id = 'kosovo-orderingwords';

import { ItemMode } from '../../../model/interfaces';
import { itemDefinitionFactoryProvider } from '../../factoryProvider';


itemDefinitionFactoryProvider.register({
    id: id,
    uuid: '6a07fe5a-5f23-4afb-9978-ff24998ce99f',
    widgetNames: {
        fallback: 'itemdefinition-' + id,
        modes: new Map<ItemMode, string>([
            ['EDIT', `itemdefinition-${id}-edit`]
        ])
    },
});
